//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { coinList } from '../service/getdata'

export default {
    name: 'QuotesSpotList',
    data() {
        return {
            coinList: [],
            sort: 1,
            timerInfo: null
        }
    },
    computed: {
        ...mapState(['token'])
    },
    created() {
        this.getCoinList(true)
        this.timerInfo = setInterval(() => {
            if (this.coinList.length > 0) {
                this.getCoinList(false)
            }
        }, 2000)
    },
    deactivated() {
        this.clearTimer()
    },
    beforeDestroy() {
        this.clearTimer()
    },
    methods: {
        clearTimer() {
            clearInterval(this.timerInfo)
            this.timerInfo = null
        },
        getCoinList(isLoading) {
            if (isLoading) {
                this.coinList = []
                // this.$Loading()
            }
            
            let that = this
            coinList({ token: this.token, type: this.sort }).then(res => {
                res = res.data;
                if (isLoading && that.$Loading) {
                    that.$Loading.close()
                }
                if (res.status == '1') {
                    that.coinList = res.data
                } else if (res.status == '-1') {
                    that.$router.push('/pages/relogin')
                }
            }).catch(() => {
                if (isLoading && that.$Loading) {
                    that.$Loading.close()
                }
                console.log("error")
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/QuotesSpotList.vue